<template>
    <div>
        <stream-item
            @select="menuItemSelected"
            :menu-options="menuOptions"
            :icon="data.medium === 'email' ? 'email' : 'phone_iphone'"
            line-type="dashed"
        >
            <div class="activity-stream-item">
                <div class="activity-stream-item-message" v-if="data.preview">
                    <div @click="menuItemSelected({id: 'view'})" style="cursor: pointer; font-size: 1.1rem;"><strong>{{ data.subject }}</strong></div>
                    <div v-if="data.medium === 'text'">{{ data.preview | limit(112) }}</div>
                    <div style="color: #999">{{ data.sent_at | formatDate }} | {{ data.from_name }} → {{ data.to_name }}</div>
                    <div v-if="data.medium === 'email'">{{ data.preview | limit(112) }}</div>
                </div>
            </div>
        </stream-item>
    </div>
</template>

<script>
import StreamItem from "./StreamItem";
import StreamItemHeader from "./StreamItemHeader";
import Filters from '../../../filters'

    const menuOptions = [
        {
            id: 'view',
            icon: 'link',
            label: 'View Full Message'
        }
    ]

export default {
    filters: { ...Filters, limit(value, length) { return value.substr(0, length) + (value.length > length ? '...' : '') } },
    components: { StreamItem, StreamItemHeader },
    props: {
        data: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            menuOptions
        }
    },
    methods: {
        menuItemSelected(item) {
            if (item.id === 'view') {
                this.$root.navigateTo('inbox/' + this.data.conversation.message_box_id + '/conversations/' + this.data.conversation_id + '/' + this.data.id)
            }
        }
    }
}
</script>

<style scoped>
    .activity-stream-item {
        padding-bottom: 1.5rem;
    }
</style>